parasails.registerPage('chirp', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    syncing: false,
    formData: { /* … */ },
    formErrors: { /* … */ },
    formRules: {
      fullName: {required: true},
      message: {required: true},
    },
    cloudError: '',
    cloudSuccess: false,
    currentPartData: {},
    currentPartIndex: 0,
    shouldShowConfirm: true,
    confirmSendModal: false,
    chirpAgainTimeoutID: undefined,
    freeSwitch: false,
    additionalstyle: '',
    backgroundStyle: 'background-image: url("../images/chirp/chirp-bg.webp");',
    eventLogo: 'images/chirp/chirp-logo.webp',
    showNameInput: false,
    newlineCharacter: "%0A",
    hashtagCharacter: "%23",
    hashtags: ""
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    //…
    this.setBGStyle();
    this.setLogo();
    //Update after testing with correct info.
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.currentPartIndex = 0;
    if(this.eventData.parts.length > 0) {
      if(this.eventData.focusPartID != null) {
        //This event has a focus part, so we need to find it and set the partIndex to that...
        for(var fpi = 0; fpi < this.eventData.parts.length; fpi++) {
          if(this.eventData.parts[fpi].id === this.eventData.focusPartID) {
            this.partIndex = fpi;
            break;
          }
        }
      } else {
        for(var pi = 0; pi < this.eventData.parts.length; pi++) {
          if(this.eventData.parts[pi].isLive) {
            this.currentPartIndex = pi;
            break;
          }
        }
      }
    }
    this.currentPartData = this.eventData.parts[this.currentPartIndex];
    this.formData.eventid = this.eventData.id;
    this.formData.partid = this.currentPartIndex;
    this.freeSwitch = this.currentPartData.freeSwitch;
    this.setHashtags();

    if(this.freeSwitch === true) {
      //Free switch means the user is able to freely switch between stamp and chirp.
    } else if(this.currentPartData.partType !== 'tweet' && this.currentPartData.partType !== 'chirp') {
      //Redirect to mobile page...
      this.goto('/quapi-mobile?eventID=' + this.overallEventID);
    }

    if(this.currentPartData.hasOwnProperty('eventPartOptions')) {
      this.shouldShowConfirm = (this.currentPartData.eventPartOptions.hasOwnProperty('shouldShowConfirm')) ? this.currentPartData.eventPartOptions.shouldShowConfirm : true;
    }

    io.socket.on(this.eventData.id, (params) => {
      switch(params.eventType) {
        case 'startpart':
          this.currentPartData = this.eventData.parts[params.partindex];
          if(this.freeSwitch === true) {
            //Free switch means the user is able to freely switch between stamp and chirp.
          } else if(this.currentPartData.partType !== 'tweet' && this.currentPartData.partType !== 'chirp') {
            //Redirect to mobile page...
            this.goto('/quapi-mobile?eventID=' + this.overallEventID);
          }
          break;
        case 'dataupdated':
          location.reload();
          break;
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    confirmSubmit() {
      if(this.shouldShowConfirm) {
        this.confirmSendModal = true;
      }
    },
    submittedForm: async function() {
      // Show the success message.
      this.cloudSuccess = true;
      this.confirmSendModal = false;

      this.chirpAgainTimeoutID = setTimeout(this.chirpagain, 5000);
    },
    chirpagain() {
      clearTimeout(this.chirpAgainTimeoutID);
      this.formData = {}; // Clear the form data object
      this.formErrors = {}; // Clear the form errors object
      this.cloudSuccess = false;
      this.confirmSendModal = false;
      this.syncing = false;
      this.cloudError = '';
      this.formData.eventid = this.eventData.id;
      this.formData.partid = this.currentPartIndex;
    },
    switchToQuapiMobile()
    {
      this.goto('/quapi-mobile?eventID=' + this.overallEventID);
    },
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
    },
    setBGStyle() {
      var bgImage = '../images/chirp/chirp-bg.webp';
      var bgIsColor = false;

      //before checking the part bg, check the if this is a vote and has a bg set for each question...
      if(this.currentPartData) {
        if(this.currentPartData && this.currentPartData.BGImage && this.currentPartData.BGImage !== '') {
          bgImage = this.currentPartData.BGImage;
        } else {
          if(this.eventData.BGImage && this.eventData.BGImage !== '') {
            bgImage = this.eventData.BGImage;
          }
        }
      } else if(this.eventData.BGImage && this.eventData.BGImage !== '') {
        bgImage = this.eventData.BGImage;
      }

      bgIsColor = this.eventData.BGImage.startsWith('#') === true;

      if(bgIsColor === true) {
        this.backgroundStyle = this.additionalstyle + ' background-color: ' + bgImage.toLowerCase() + ' !important;';
      } else {
        this.backgroundStyle = 'background-image: url(\'' + bgImage + '\') !important; ' + this.additionalstyle;
      }
    },
    setHashtags() {
      try {
        if(this.currentPartData.hashtags && this.currentPartData.hashtags.length > 0) {
          var localHashtags = this.currentPartData.hashtags.join(' ' + this.hashtagCharacter);
          this.hashtags = this.newlineCharacter + this.newlineCharacter + this.hashtagCharacter + localHashtags + this.newlineCharacter;
        }
      } catch(err) {
        console.log(err);
      }
    }
  }
});
